export const computerMenuText = "qbc";
export const cloudLocationsMenuText = "rbc";
export const uploadAndShareFromCloudMenuText = "sbc";
export const uploadAndShareFromCloudMenuTooltip = "tbc";
export default {computerMenuText,cloudLocationsMenuText,uploadAndShareFromCloudMenuText,uploadAndShareFromCloudMenuTooltip};